/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Home_BudgetInputs */

const en_gc_home_budget = /** @type {(inputs: Gc_Home_BudgetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monthly budget`)
};

const zh_gc_home_budget = /** @type {(inputs: Gc_Home_BudgetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`月度预算`)
};

/**
* | output |
* | --- |
* | "Monthly budget" |
*
* @param {Gc_Home_BudgetInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_home_budget = /** @type {((inputs?: Gc_Home_BudgetInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Home_BudgetInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_home_budget(inputs)
	return zh_gc_home_budget(inputs)
});
export { gc_home_budget as "gc.home.budget" }